<template>
  <div class="share_box">
    <van-share-sheet v-model="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
    <!-- 分享提示 -->
    <van-overlay :show="isShowShare" @click="isShowShare = false" z-index="99999">
      <div class="wrapper" @click.stop>
        <img
          :src="'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_share.png'"
          alt
        />
        <img
          @click="isShowShare = false"
          class="n_shareBtn"
          :src="'https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/byj_utton.png'"
          alt
        />
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'shareMain',
  data() {
    return {
      options: [
        { name: '微信', icon: 'wechat' },
        { name: '朋友圈', icon: 'wechat-moments' },
      ],
      isShowShare: false,
      showShare: false,
    }
  },
  created() {},
  methods: {
    onSelect() {
      this.isShowShare = true
      this.showShare = false
    },
    // 分享
    openShareFg() {
      this.showShare = true
      console.log('11111111')
    },
  },
  watch: {
    showShare(key) {
      this.isShowShare = true
      this.showShare = false
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper img {
  width: 80%;
  margin: 40px auto 0;
}
.n_shareBtn {
  display: block;
  width: 236px !important;
  margin: 400px auto 0;
}
</style>